export const TELEGRAM_BOT_URL = 'https://t.me/play_arkham_horror_bot';
